
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.965 21.678h-2.787l-2.09-8.088c-.099-.372-.31-.701-.62-.856a8.982 8.982 0 00-2.554-.856v-.312h4.49c.619 0 1.084.468 1.161 1.011l1.084 5.834 2.786-6.845h2.709l-4.18 10.112zm5.728 0h-2.632l2.167-10.112h2.632l-2.167 10.112zm5.572-7.31c.078-.545.542-.856 1.084-.856a4.843 4.843 0 012.555.466l.464-2.177a6.577 6.577 0 00-2.4-.468c-2.553 0-4.412 1.4-4.412 3.345 0 1.478 1.316 2.255 2.246 2.723 1.005.466 1.392.777 1.315 1.244 0 .7-.774 1.01-1.548 1.01-.929 0-1.858-.233-2.709-.622l-.465 2.178c.93.388 1.935.545 2.865.545 2.864.077 4.644-1.323 4.644-3.423 0-2.644-3.639-2.8-3.639-3.965zm12.85 7.31l-2.09-10.112H33.78c-.465 0-.93.312-1.084.778l-3.87 9.334h2.71l.54-1.478h3.33l.309 1.478h2.4zm-3.948-7.389l.773 3.811h-2.167l1.394-3.81z","fill":"#172B85"}})])
          )
        }
      }
    